/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Gender } from './gender';
import { Language } from './language';
import { MiddleNameString } from './middleNameString';
import { NameString } from './nameString';
import { Suffixes } from './suffixes';

export interface Individual { 
    gender?: Gender;
    date_of_birth?: string;
    first_name?: NameString;
    last_name?: NameString;
    middle_name?: MiddleNameString;
    suffix?: Suffixes;
    language?: Array<Language>;
}